import { render, staticRenderFns } from "./EditPromoCodeLoader.vue?vue&type=template&id=fae03e70"
import script from "./EditPromoCodeLoader.vue?vue&type=script&lang=ts"
export * from "./EditPromoCodeLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports